import { exportRows } from '../../datatables/table-setup';

// Copy / Print / Export-to-CSV for a Track / Overview side panel. The panel is a
// plain list (not a DataTable), so we read the rendered rows — Full Name, Email,
// people-tag chips, and the response value on the question "responses" panel —
// and hand them to the shared report export (same layout / filename / footer as
// Track / Individual). Only the rows currently visible (respecting the panel
// search) are exported.
const text = el => (el ? el.textContent.trim() : '');

const SidepanelExport = {
  bind($sidepanel) {
    $sidepanel
      .find('.js-sidepanel-export')
      .off('click.sidepanelExport')
      .on('click.sidepanelExport', (event) => {
        event.preventDefault();
        this.run($sidepanel, event.currentTarget);
      });
  },

  run($sidepanel, link) {
    const panes = $sidepanel.find('article.pane').filter(':visible').toArray();
    if (!panes.length) return;

    const baseColumns = JSON.parse(link.dataset.exportColumns || '[]');
    const responseLabel = link.dataset.exportResponseLabel;
    const withResponse = responseLabel && panes.some(pane => pane.querySelector('.pane__quote'));
    const columns = withResponse ? [...baseColumns, responseLabel] : baseColumns;

    const rows = panes.map((pane) => {
      const info = pane.querySelector('.pane__info');
      const tags = Array.from(info ? info.querySelectorAll('.tag') : [])
        .map(tag => tag.textContent.trim())
        .join(', ');
      const row = [
        text(info && info.querySelector('strong')), // full name
        text(info && info.querySelector('p')), // email (first line under the name)
        tags
      ];
      if (withResponse) row.push(text(pane.querySelector('.pane__quote')));
      return row;
    });

    exportRows({ type: link.dataset.sidepanelExport, columns, rows, header: this.header($sidepanel, link) });
  },

  // The report heading / filename / footer for the export. Question panels are
  // question-centric: heading = question field name, subtitle = the question text,
  // and both the browser title/filename and the footer read "Event - Activity".
  // Every other panel keeps its own subtitle as the heading and the event as the
  // doc/footer name ("Event - <panel context>").
  header($sidepanel, link) {
    const { exportDocTitle, exportSubtitle, exportQuestionName, exportQuestionSubtitle } = link.dataset;
    if (exportQuestionName) {
      const eventActivity = [exportDocTitle, exportSubtitle].filter(Boolean).join(' - ');
      return {
        title: exportQuestionName,
        subtitle: exportQuestionSubtitle || '',
        printTitle: eventActivity,
        footerName: eventActivity
      };
    }
    return {
      docTitle: exportDocTitle,
      title: text($sidepanel.find('.subtitle--center')[0]), // the panel's own subtitle (e.g. "Attending")
      subtitle: exportSubtitle
    };
  }
};

export default SidepanelExport;
